
import { defineComponent, PropType } from "vue";
import { SkinProfile } from "@/controller/skin-profile";
import SkinProfileIcon from "./SkinProfileIcon.vue";
import ConfirmModal from "./ConfirmModal.vue";

interface SkinInfo {
  icon: string;
  iconColor: string;
  iconType: string;
  label: string;
  title: string;
}

export default defineComponent({
  name: "SkinProfileRow",

  components: {
    SkinProfileIcon,
    ConfirmModal
  },

  props: {
    skinProfile: {
      type: Object as PropType<SkinProfile>,
      required: true
    }
  },

  data() {
    return {
      isDeleting: false
    };
  },

  computed: {
    url(): string {
      return this.skinProfile.url;
    },

    date(): string {
      const date = this.skinProfile.date;
      const year = date.getFullYear();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      return `${day} Tháng ${month}, ${year}`;
    },

    skinInfo(): SkinInfo[] {
      return [
        {
          icon: "heart",
          iconColor: "red",
          iconType: "fas",
          title: "Cảm thấy",
          label: this.skinProfile.feeling
        },
        {
          icon: "allergies",
          iconColor: "orange",
          iconType: "fas",
          title: "Loại da",
          label: this.skinProfile.skinType
        },
        {
          icon: "clock",
          iconColor: "navy",
          iconType: "fas",
          title: "Thời gian",
          label: this.skinProfile.skinTime
        },
        {
          icon: "moon",
          iconColor: "darkseagreen",
          iconType: "fas",
          title: "Giấc ngủ",
          label: this.skinProfile.sleep
        },
        {
          icon: "clipboard",
          iconColor: "black",
          iconType: "far",
          title: "Ghi chú",
          label: this.skinProfile.note
        }
      ];
    }
  },

  methods: {
    showConfirmModal() {
      this.isDeleting = true;
    },

    closeConfirmModal() {
      this.isDeleting = false;
    },

    emitDelete() {
      this.$emit("delete", this.skinProfile.id);
      this.closeConfirmModal();
    }
  }
});
